import React, { useState, useEffect } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { AppProvider, useApp } from './context/AppContext';
import Landing from './pages/Landing';
import Intro from './pages/Intro';
import Consent from './pages/Consent';
import Quiz from './pages/Quiz';
import RadarResult from './pages/RadarResult';
import RadarPage from './pages/RadarPage';
import Result from './pages/Result';
import Share from './pages/Share';
import Explore from './pages/Explore';
import Gallery from './pages/Gallery';
import LiveHost from './pages/LiveHost';
import LiveQuiz from './pages/LiveQuiz';
import OraclePage from './pages/OraclePage';
import DrawingPage from './pages/DrawingPage';
import './styles/global.css';

// 页面转场动画配置
const pageVariants = {
  initial: {
    opacity: 0,
    scale: 0.98,
    filter: 'blur(10px)',
  },
  animate: {
    opacity: 1,
    scale: 1,
    filter: 'blur(0px)',
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94],
    },
  },
  exit: {
    opacity: 0,
    scale: 1.02,
    filter: 'blur(10px)',
    transition: {
      duration: 0.3,
      ease: [0.25, 0.46, 0.45, 0.94],
    },
  },
};

function PageRouter() {
  const { state } = useApp();
  
  const pages = {
    landing: <Landing />,
    intro: <Intro />,
    consent: <Consent />,
    quiz: <Quiz />,
    radarResult: <RadarResult />,
    radarPage: <RadarPage />,
    result: <Result />,
    share: <Share />,
    explore: <Explore />,
    gallery: <Gallery />,
    liveHost: <LiveHost />,
    oracle: <OraclePage />,
    drawing: <DrawingPage />,
  };
  
  return (
    <div className="app-container">
      <AnimatePresence mode="wait">
        <motion.div
          key={state.currentPage}
          variants={pageVariants}
          initial="initial"
          animate="animate"
          exit="exit"
          style={{ width: '100%', height: '100%' }}
        >
          {pages[state.currentPage]}
        </motion.div>
      </AnimatePresence>
    </div>
  );
}

function App() {
  const [liveRoomId, setLiveRoomId] = useState(null);

  useEffect(() => {
    // 检查 URL 参数是否有 live 房间号
    const params = new URLSearchParams(window.location.search);
    const roomId = params.get('live');
    if (roomId) {
      setLiveRoomId(roomId);
    }
  }, []);

  // 如果是扫码进入的观众模式
  if (liveRoomId) {
    return (
      <LiveQuiz 
        roomId={liveRoomId} 
        onExit={() => {
          window.history.replaceState({}, '', window.location.pathname);
          setLiveRoomId(null);
        }} 
      />
    );
  }

  return (
    <AppProvider>
      <PageRouter />
    </AppProvider>
  );
}

export default App;
